import styled, { createGlobalStyle, keyframes } from 'styled-components'

export const GlobalStyles = createGlobalStyle`
    html, body {
        height: 100%;
        width: 100%;
        background-color: ${({ theme }) => theme.colours.background.dark_blue};
        margin: 0;
        padding: 0;
        font-family: Roboto, sans-serif;
    }
    section {
        width: inherit;
    }
    *::-webkit-scrollbar {
        display: none;
    }

    * {
        -ms-overflow-style: none;
        scrollbar-width: none;
    }
`

const spin = keyframes`
    to { transform: rotate(360deg); }
`

export const PageLoadingContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    color: ${({ theme }) => theme.colours.font.secondary};
    font-family: Roboto, sans-serif;
    flex-direction: column;
    gap: 12px;
`

export const StyledNavSection = styled.div`
    background-color: ${({ theme }) => theme.colours.background.blue};
    border-radius: 12px;
    margin-top: 8px;
    margin-bottom: 12px;
    overflow: visible;
`

export const PageLoadingSpinner = styled.div`
    width: 32px;
    height: 32px;
    border: 3px solid ${({ theme }) => theme.colours.border.primary};
    border-top-color: ${({ theme }) => theme.colours.font.green};
    border-radius: 50%;
    animation: ${spin} 1s linear infinite;
`
